import {HttpClient, HttpHandler} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';

@Injectable()

export class SecureEftApi extends HttpClient {
    private baseUrl = environment.production ? "/channel-virtual/api/v1" + '/secure-eft' : environment.baseUrl + '/secure-eft';

    public constructor(handler: HttpHandler) {
      super(handler);
    }

    public initializePayment(sessionToken: string): Observable<any> {
      const url = this.baseUrl + `/initialize?sessionToken=${sessionToken}`;
      return super.post(url, "");
    }

    public getTransactionStatus(sessionToken: string): Observable<object> {
      const url = this.baseUrl + `/validate/${sessionToken}`;
      return super.get(url);
    }

}
